(function(app) {

    app.constant("arcIds",
    {
        libertyGroupCommissionGroupId: 286
    });

})(window.app);